import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Componente per aggiungere dati strutturati JSON-LD
 * @param {Object} props - Proprietà del componente
 * @param {Object} props.data - Dati strutturati da inserire
 */
const JsonLd = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

export default JsonLd;